/**
 * Your Kit Includes - Drawer functionality + Dynamic Content
 * 
 * Handles:
 * - Size-based dynamic components (gallons, pearls, topcoat)
 * - Sprayer selection (G-Force, Ultimate, or None) - PEELABLE KITS
 * - Finish selection (Standard or UHG - added to dynamic items) - PEELABLE KITS
 * - Primer selection (Requires Primer or Good Condition) - PERMANENT KITS
 * - Clearcoat selection (Standard or VHS) - PERMANENT KITS
 * - Mobile drawer (same pattern as accessories-drawer.js)
 */
(function() {
  // ===== PEELABLE CAR KIT PRODUCTS =====
  
  // Sprayer product data (real product images from Shopify)
  const SPRAYER_PRODUCTS = {
    'g-force': {
      title: 'G-Force DipSprayer System',
      handle: 'dipsprayer-system-base-kit',
      image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/GForceFullSystemCompact_1024x1024_e494a940-7cef-4ec8-b65e-229ae8ec71bf.png?v=1679328607'
    },
    'ultimate': {
      title: 'Ultimate DipSprayer System',
      handle: 'dyc-ultimate-dipsprayer-system-w-g-force-spray-gun', 
      image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/UltimateFullSystem.png?v=1760807825'
    }
  };
  
  // UHG product data (real product image from Shopify)
  const UHG_PRODUCT = {
    title: 'Ultra High Gloss Topcoat',
    handle: 'ultra-high-gloss-kit',
    image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/UHG_Kit.webp?v=1767019443'
  };
  
  // AutoFlex (pearl kit UHG add-on) – fallback image when metafield has none
  const AUTOFLEX_FALLBACK_IMAGE = 'https://cdn.shopify.com/s/files/1/0973/6008/files/OneProrender_d2f1ef3c-4441-443d-97c1-404705a04b08.webp?v=1742844709';
  
  // ===== PERMANENT CAR KIT PRODUCTS =====
  
  // Clearcoat products for permanent kits
  const CLEARCOAT_PRODUCTS = {
    'standard': {
      title: 'Luna Standard Clearcoat 4.7L Kit',
      handle: 'luna-standard-clearcoat-4-7l-kit',
      image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/standard_white_back.webp?v=1744722216'
    },
    'vhs': {
      title: 'Luna VHS Crystal Clearcoat 5L Kit',
      handle: 'luna-vhs-cleacoat',
      image: 'https://cdn.shopify.com/s/files/1/0973/6008/files/VHS_clearcoat_white_back.webp?v=1744722194'
    }
  };
  
  // Wait for DOM to be ready (AFTER constants are defined)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKitIncludesDrawer);
  } else {
    initKitIncludesDrawer();
  }
  
  function initKitIncludesDrawer() {
    console.log('📦 Kit Includes Drawer: Initializing...');
    
    // querySelectorAll, not querySelector: there can be more than one trigger for the
    // same drawer (the in-section pill, plus the buy-column card in main-product-alt).
    // Binding only the first match in DOM order would leave the others inert.
    const triggers = document.querySelectorAll('[data-kit-includes-trigger]');
    const drawer = document.querySelector('[data-kit-includes-drawer]');
    const overlay = document.querySelector('[data-kit-includes-overlay]');
    const closeBtn = document.querySelector('[data-kit-includes-close]');

    console.log('📦 Elements found:', {
      triggers: triggers.length,
      drawer: !!drawer,
      overlay: !!overlay,
      closeBtn: !!closeBtn
    });

    const hasKitDrawer = !!(triggers.length && drawer && overlay);
    if (!hasKitDrawer) {
      console.log('📦 Kit Includes: Kit drawer not present (mobile display mode may be static)');
    }

    if (hasKitDrawer) {
      console.log('✅ All kit drawer elements found! Setting up event listeners...');
    
      // Open drawer — bind every trigger on the page
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          console.log('🚀 Kit trigger clicked!');
          e.preventDefault();
          e.stopPropagation();
          drawer.classList.add('is-open');
          overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          console.log('✅ Drawer opened');
        }, true);
      });
    
      // Close drawer function
      const close = () => {
        console.log('🔒 Closing drawer...');
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        console.log('✅ Drawer closed');
      };
    
      if (closeBtn) {
        closeBtn.addEventListener('click', close);
        console.log('✅ Close button listener added');
      }
    
      if (overlay) {
        overlay.addEventListener('click', close);
        console.log('✅ Overlay listener added');
      }
    
      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          close();
        }
      });
      console.log('✅ ESC key listener added');

      // CSS handles all drawer positioning and animations (Android-safe)
      // No inline styles or MutationObservers needed
      console.log('✅ Kit Includes Drawer: Ready (CSS-only mode)');
    }

    // Always initialize dynamic content + quick view (even when kit drawer is disabled on mobile)
    initDynamicContent();
    initQuickViewTriggers();
    initSectionVisibility();
  }
  
  /**
   * Initialize section visibility - always visible when kit data exists
   */
  function initSectionVisibility() {
    const section = document.querySelector('.your-kit-includes-section');
    const trigger = document.querySelector('.your-kit-includes-trigger');

    if (!section) {
      console.log('📦 Kit Includes: Section not found');
      return;
    }

    // Always reveal — section should be visible whenever kit data exists
    section.classList.remove('is-hidden');
    if (trigger) {
      trigger.classList.remove('is-hidden');
    }
    console.log('✅ Kit Includes: Section visible');
  }
  
  /**
   * Initialize "View Details" quick view triggers for static items
   * Uses drawer pattern matching accessories-drawer exactly
   */
  function initQuickViewTriggers() {
    const drawer = document.querySelector('[data-kit-quickview-drawer]');
    const overlay = document.querySelector('[data-kit-quickview-overlay]');
    const closeBtn = document.querySelector('[data-kit-quickview-close]');
    const productArea = document.querySelector('[data-kit-quickview-product]');
    
    if (!drawer || !overlay || !productArea) {
      console.log('📦 Quick view drawer elements not found');
      return;
    }
    
    // CSS handles all drawer positioning and animations (Android-safe)
    // No inline styles or MutationObservers needed

    // Close drawer function
    const closeQuickView = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    
    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeQuickView);
    }
    
    // Overlay click
    overlay.addEventListener('click', closeQuickView);
    
    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeQuickView();
      }
    });
    
    // Skeleton loader HTML
    const skeletonHtml = `
      <div class="kit-quickview-drawer__skeleton">
        <div class="skeleton-image"></div>
        <div class="skeleton-title"></div>
        <div class="skeleton-description"></div>
        <div class="skeleton-description short"></div>
      </div>
    `;
    
    // Cache for fetched product content (makes repeat views instant)
    const productCache = new Map();
    let currentFetchController = null;
    
    // Open drawer and load product content
    const openQuickView = async (productUrl) => {
      // Abort any in-flight request
      if (currentFetchController) {
        currentFetchController.abort();
      }
      currentFetchController = new AbortController();
      
      const contentEl = drawer.querySelector('[data-kit-quickview-content]');
      
      // Check cache first - if we have it, show immediately
      if (productCache.has(productUrl)) {
        console.log('📦 Quick View: Loading from cache');
        productArea.innerHTML = productCache.get(productUrl);
        if (contentEl) contentEl.scrollTop = 0;
        
        // Open drawer
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        return;
      }
      
      // Show skeleton while loading
      productArea.innerHTML = skeletonHtml;
      if (contentEl) contentEl.scrollTop = 0;
      
      // Force layout paint before opening
      void productArea.offsetHeight;
      
      // Open drawer with skeleton visible
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      
      try {
        // Build optimized fetch URL using section rendering (smaller payload)
        const fetchUrl = buildFetchUrl(productUrl);
        console.log('📦 Quick View: Fetching', fetchUrl);
        
        const response = await fetch(fetchUrl, {
          signal: currentFetchController.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        
        // Build clean educational content (image + title + description only)
        const cleanHtml = buildEducationalContent(doc, productUrl);
        
        // Cache the result
        productCache.set(productUrl, cleanHtml);
        
        // Smooth transition: fade in the content
        productArea.style.opacity = '0';
        productArea.innerHTML = cleanHtml;
        
        // Trigger fade in
        requestAnimationFrame(() => {
          productArea.style.transition = 'opacity 0.2s ease';
          productArea.style.opacity = '1';
        });
        
        // Initialize lazy loading if available
        if (typeof initializeScrollLazyImageTrigger === 'function') {
          initializeScrollLazyImageTrigger();
        }
        
        console.log('✅ Product content loaded successfully');
        
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('📦 Quick View: Request aborted');
          return;
        }
        
        console.error('Error loading product:', error);
        productArea.innerHTML = `
          <div class="kit-quickview-drawer__error">
            <p>Unable to load product details.</p>
            <a href="${productUrl}" class="product-link">View Full Product Page</a>
          </div>
        `;
      }
    };
    
    /**
     * Build optimized fetch URL - try section rendering first for smaller payload
     */
    function buildFetchUrl(productUrl) {
      try {
        const url = new URL(productUrl, window.location.origin);
        // Use section_id for lighter payload (only the product section, not full page)
        url.searchParams.set('section_id', 'main-product');
        return url.toString();
      } catch (e) {
        return productUrl;
      }
    }
    
    /**
     * Build clean educational content - just image, title, and description
     * Much lighter than injecting the full product section
     */
    function buildEducationalContent(doc, productUrl) {
      // Get product image - try multiple sources
      let imageUrl = '';
      const ogImage = doc.querySelector('meta[property="og:image"]');
      const productImage = doc.querySelector('.product-media img, .product__media img, [data-product-media] img');
      const featuredImage = doc.querySelector('.product-featured-media img, .product-main-image img');
      
      if (ogImage) {
        imageUrl = ogImage.getAttribute('content') || '';
      } else if (productImage) {
        imageUrl = productImage.getAttribute('src') || productImage.dataset.src || '';
      } else if (featuredImage) {
        imageUrl = featuredImage.getAttribute('src') || featuredImage.dataset.src || '';
      }
      
      // Get product title
      let title = '';
      const titleEl = doc.querySelector('.heading-size--large, .product__title, .product-title, h1.title, h1');
      if (titleEl) {
        title = titleEl.textContent?.trim() || '';
      } else {
        const ogTitle = doc.querySelector('meta[property="og:title"]');
        title = ogTitle?.getAttribute('content') || 'Product Details';
      }
      
      // Get product description
      let description = '';
      const descEl = doc.querySelector('.product__description, .product-description, [data-product-description], .rte');
      if (descEl) {
        description = descEl.innerHTML || '';
      } else {
        const ogDesc = doc.querySelector('meta[property="og:description"]');
        if (ogDesc) {
          description = `<p>${escapeHtml(ogDesc.getAttribute('content') || '')}</p>`;
        }
      }
      
      // Build clean HTML
      return `
        <div class="kit-quickview-educational">
          ${imageUrl ? `
            <div class="kit-quickview-educational__image">
              <img src="${imageUrl}" alt="${escapeHtml(title)}" loading="eager">
            </div>
          ` : ''}
          <h2 class="kit-quickview-educational__title heading-size--large">${escapeHtml(title)}</h2>
          ${description ? `
            <div class="kit-quickview-educational__description rte">
              ${description}
            </div>
          ` : ''}
          <a href="${productUrl}" class="kit-quickview-educational__link">
            View Full Product Page →
          </a>
        </div>
      `;
    }
    
    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    
    // Add click listeners to all quick view triggers
    const triggers = document.querySelectorAll('[data-quick-view-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const productUrl = trigger.getAttribute('data-product-url');
        
        if (productUrl) {
          openQuickView(productUrl);
        }
      });
    });
    
    // PREFETCH: Load all "Always Included" products in the background
    // This makes "View Details" instant when clicked
    prefetchProducts(triggers);
    
    // DEBUG: Add global test function
    window.testKitQuickViewDrawer = function() {
      if (drawer && overlay) {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        console.log('🧪 Quick view drawer classes added');
      }
    };
    
    console.log('✅ Quick view drawer initialized');
    
    /**
     * Prefetch all product content in background after page load
     * Uses requestIdleCallback for non-blocking prefetch
     */
    function prefetchProducts(triggerElements) {
      if (!triggerElements || triggerElements.length === 0) return;
      
      // Collect unique product URLs
      const urls = new Set();
      triggerElements.forEach(trigger => {
        const url = trigger.getAttribute('data-product-url');
        if (url && !productCache.has(url)) {
          urls.add(url);
        }
      });
      
      if (urls.size === 0) {
        console.log('📦 Prefetch: All products already cached');
        return;
      }
      
      console.log(`📦 Prefetch: Will prefetch ${urls.size} products in background`);
      
      // Use requestIdleCallback if available, otherwise setTimeout
      const scheduleWork = window.requestIdleCallback || ((cb) => setTimeout(cb, 100));
      
      // Prefetch each product with a delay to avoid blocking
      const urlArray = Array.from(urls);
      let index = 0;
      
      function prefetchNext() {
        if (index >= urlArray.length) {
          console.log('📦 Prefetch: Complete! All products cached.');
          return;
        }
        
        const url = urlArray[index];
        index++;
        
        // Fetch in background
        prefetchProduct(url).then(() => {
          // Schedule next prefetch when idle
          scheduleWork(prefetchNext);
        });
      }
      
      // Start prefetching after a short delay (let critical resources load first)
      setTimeout(() => {
        scheduleWork(prefetchNext);
      }, 1500);
    }
    
    /**
     * Prefetch a single product and cache the result
     */
    async function prefetchProduct(productUrl) {
      if (productCache.has(productUrl)) return;
      
      try {
        const fetchUrl = buildFetchUrl(productUrl);
        
        const response = await fetch(fetchUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          priority: 'low' // Low priority - don't compete with user actions
        });
        
        if (!response.ok) return;
        
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        
        // Build and cache the clean content
        const cleanHtml = buildEducationalContent(doc, productUrl);
        productCache.set(productUrl, cleanHtml);
        
        console.log(`📦 Prefetched: ${productUrl.split('/').pop()}`);
        
      } catch (error) {
        // Silently fail for prefetch - not critical
        console.log(`📦 Prefetch failed: ${productUrl.split('/').pop()}`);
      }
    }
  }
  
  /**
   * Initialize dynamic content updates based on Size/Sprayer/Finish selection
   */
  function initDynamicContent() {
    const container = document.querySelector('.your-kit-includes');
    const dataScript = container?.querySelector('[data-kit-components-data]');
    
    if (!dataScript) {
      console.log('📦 Kit Includes: No dynamic data found');
      return;
    }
    
    let kitData = null;
    try {
      kitData = JSON.parse(dataScript.textContent.trim());
      console.log('📦 Kit Includes: Loaded kit data', kitData);
    } catch (e) {
      console.error('📦 Kit Includes: Failed to parse kit data', e);
      return;
    }
    
    // Target containers (both inline and drawer)
    const dynamicContainers = document.querySelectorAll('[data-kit-dynamic-items], [data-kit-drawer-dynamic-items]');
    
    // Detect kit type: Permanent kits have primerProducts, Peelable kits don't
    const isPermanentKit = kitData.primerProducts != null && typeof kitData.primerProducts === 'object';
    console.log('📦 Kit type:', isPermanentKit ? 'PERMANENT' : 'PEELABLE');
    
    // Current selections - shared
    let currentSize = 'Medium';
    
    // Peelable kit selections
    let currentSprayer = null; // null = not selected, 'g-force', 'ultimate', 'none'
    let currentFinish = 'standard'; // 'standard' or 'uhg'
    
    // Permanent kit selections
    let currentPrimer = false; // false = Good Condition, true = Requires Primer
    let currentClearcoat = 'standard'; // 'standard' or 'vhs'
    
    /**
     * Render all dynamic components based on current selections
     */
    function renderComponents() {
      const sizeKey = normalizeSize(currentSize);
      const isExtraLarge = sizeKey === 'Extra Large';
      
      // Start with size-based components
      let allComponents = [...(kitData.sizes?.[sizeKey] || [])];
      
      // When UHG is selected (peelable), remove the standard topcoat from the list; capture its qty so AutoFlex row uses same qty
      let standardTopcoatQty = isExtraLarge ? 2 : 1; // fallback
      const standardFinish = kitData.finishProducts?.standard;
      if (!isPermanentKit && currentFinish === 'uhg' && standardFinish?.handle) {
        const standardHandle = (standardFinish.handle || '').toLowerCase();
        const removed = allComponents.find(c => {
          const h = (c.productHandle || c.handle || '').toLowerCase();
          return standardHandle && h && (h === standardHandle || h.includes(standardHandle));
        });
        if (removed != null && typeof removed.qty === 'number') standardTopcoatQty = removed.qty;
        allComponents = allComponents.filter(c => {
          const h = (c.productHandle || c.handle || '').toLowerCase();
          return !h || !standardHandle || (h !== standardHandle && !h.includes(standardHandle));
        });
      }
      
      // Count total items to determine column count
      let totalItems = allComponents.length;
      
      if (isPermanentKit) {
        // PERMANENT KIT: Count primer products (if selected) + clearcoat (always)
        if (currentPrimer && kitData.primerProducts?.[sizeKey]) {
          totalItems += kitData.primerProducts[sizeKey].length;
        }
        totalItems++; // Clearcoat is always shown
      } else {
        // PEELABLE KIT: Count sprayer (if selected) + UHG row + optional extra kit product (e.g. AutoFlex for pearl kits)
        if (currentSprayer && currentSprayer !== 'none') totalItems++;
        if (currentFinish === 'uhg') {
          totalItems++; // UHG product row (always)
          const uhgEntry = kitData.finishProducts?.uhg;
          if (uhgEntry?.handle && (uhgEntry.handle.toLowerCase() !== 'ultra-high-gloss-kit')) totalItems++; // different product in kit (e.g. AutoFlex)
        }
      }
      
      // Auto-calculate columns: 3, 4, or 5 based on item count
      let dynamicCols = Math.min(Math.max(totalItems, 3), 5);
      
      console.log('📦 Rendering components:', { 
        kitType: isPermanentKit ? 'PERMANENT' : 'PEELABLE',
        size: sizeKey, 
        sprayer: currentSprayer, 
        finish: currentFinish,
        primer: currentPrimer,
        clearcoat: currentClearcoat,
        baseComponents: allComponents.length,
        totalItems: totalItems,
        columns: dynamicCols
      });
      
      // Build the HTML
      let itemsHtml = '';
      
      if (isPermanentKit) {
        // ===== PERMANENT KIT RENDERING =====
        
        // 1. Render primer products if "Requires Primer" is selected
        console.log('📦 PERMANENT: Primer check', { currentPrimer, sizeKey, hasPrimerData: !!kitData.primerProducts?.[sizeKey] });
        if (currentPrimer && kitData.primerProducts?.[sizeKey]) {
          const primers = kitData.primerProducts[sizeKey];
          console.log('📦 PERMANENT: Rendering primers', primers);
          if (Array.isArray(primers)) {
            primers.forEach(primer => {
              itemsHtml += renderItem({
                productTitle: primer.title,
                productImage: primer.image,
                productHandle: primer.handle,
                name: primer.title,
                qty: primer.qty,
                unit: 'primer'
              });
            });
          }
        }
        
        // 2. Render size-based components (basecoat + color)
        console.log('📦 PERMANENT: Rendering size components', { sizeKey, count: allComponents.length, components: allComponents });
        allComponents.forEach(component => {
          itemsHtml += renderItem(component);
        });
        
        // 3. Always show the selected clearcoat (Standard or VHS)
        console.log('📦 PERMANENT: Adding clearcoat', { currentClearcoat, CLEARCOAT_PRODUCTS });
        const clearcoatData = CLEARCOAT_PRODUCTS[currentClearcoat];
        console.log('📦 PERMANENT: clearcoatData =', clearcoatData);
        if (clearcoatData) {
          const clearcoatItem = {
            productTitle: clearcoatData.title,
            productImage: clearcoatData.image,
            productHandle: clearcoatData.handle,
            name: clearcoatData.title,
            qty: 1,
            unit: 'clearcoat'
          };
          console.log('📦 PERMANENT: rendering clearcoat item', clearcoatItem);
          itemsHtml += renderItem(clearcoatItem);
        } else {
          console.log('📦 PERMANENT: NO clearcoatData found!');
        }
        
      } else {
        // ===== PEELABLE KIT RENDERING =====
        
        // 1. First, render the sprayer if selected (and not "No Sprayer")
        if (currentSprayer && currentSprayer !== 'none') {
          const sprayerData = SPRAYER_PRODUCTS[currentSprayer];
          if (sprayerData) {
            itemsHtml += renderItem({
              productTitle: sprayerData.title,
              productImage: sprayerData.image,
              name: sprayerData.title,
              qty: 1,
              unit: 'sprayer'
            });
          }
        }
        
        // 2. Render size-based components (gallons, pearls, topcoat)
        allComponents.forEach(component => {
          itemsHtml += renderItem(component);
        });
        
        // 3. When UHG is selected: always show UHG product (unchanged). If kit includes a different product (e.g. AutoFlex for pearl kits), add that as a separate row.
        if (currentFinish === 'uhg') {
          const uhgQty = isExtraLarge ? 2 : 1;
          // 3a. UHG product row – always show as "Ultra High Gloss Topcoat" with UHG image (we never relabel this)
          itemsHtml += renderItem({
            productTitle: UHG_PRODUCT.title,
            productImage: UHG_PRODUCT.image,
            name: UHG_PRODUCT.title,
            qty: uhgQty,
            unit: 'finish'
          });
          // 3b. If metafield says kit includes a different product (e.g. AutoFlex), add it as its own row (same qty as Next Gen had)
          const uhgEntry = kitData.finishProducts?.uhg;
          if (uhgEntry?.title && uhgEntry?.handle && uhgEntry.handle.toLowerCase() !== 'ultra-high-gloss-kit') {
            const isAutoFlex = uhgEntry.handle.toLowerCase().includes('autoflex');
            const imageUrl = uhgEntry.image || (isAutoFlex ? AUTOFLEX_FALLBACK_IMAGE : '');
            itemsHtml += renderItem({
              productTitle: uhgEntry.title,
              productImage: imageUrl,
              name: uhgEntry.title,
              qty: standardTopcoatQty,
              unit: 'finish'
            });
          }
        }
      }
      
      // Update all containers with dynamic column count
      dynamicContainers.forEach(c => { 
        c.innerHTML = itemsHtml;
        c.style.setProperty('--kit-dynamic-cols', dynamicCols);
        // Used for desktop special-casing (2 items should be centered but sized like a 3-col grid)
        c.dataset.itemCount = String(totalItems);
        c.dataset.twoItems = totalItems === 2 ? 'true' : 'false';
      });
      
      // Hide the old finish container if it exists (we're now using dynamic items)
      document.querySelectorAll('[data-kit-finish-item], [data-kit-drawer-finish-item]').forEach(c => {
        c.style.display = 'none';
      });
    }
    
    /**
     * Render a single item card
     */
    function renderItem(component) {
      // Use image URL directly - it's already a complete CDN URL
      const imageUrl = component.productImage || '';
      
      const imageHtml = imageUrl
        ? `<div class="your-kit-includes__item-image">
             <img src="${imageUrl}" 
                  alt="${escapeHtml(component.productTitle || component.name)}"
                  width="120" height="120" loading="lazy">
           </div>`
        : `<div class="your-kit-includes__item-image your-kit-includes__item-image--placeholder">
             <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
               <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
               <circle cx="8.5" cy="8.5" r="1.5"></circle>
               <polyline points="21 15 16 10 5 21"></polyline>
             </svg>
           </div>`;
      
      // Format quantity display
      let qtyHtml = '';
      if (component.unit === 'sprayer' || component.unit === 'finish') {
        qtyHtml = `x${component.qty}`;
      } else if (component.unit && component.unit.includes('pearl')) {
        qtyHtml = `${component.qty}g`;
      } else {
        qtyHtml = `x${component.qty}`;
      }
      
      // Build title - add size (Gallon/Quart) if unit specifies it
      let displayTitle = component.productTitle || component.name;
      const unit = (component.unit || '').toLowerCase();
      
      // For permanent kits, show the size in the title when it's gallon or quart
      // This helps distinguish items when images are the same
      if (unit === 'gallons' || unit === 'gallon') {
        // Only add if not already in the title
        if (!displayTitle.toLowerCase().includes('gallon')) {
          displayTitle = `${displayTitle} (Gallon)`;
        }
      } else if (unit === 'quarts' || unit === 'quart') {
        // Only add if not already in the title
        if (!displayTitle.toLowerCase().includes('quart')) {
          displayTitle = `${displayTitle} (Quart)`;
        }
      }
      
      return `
        <div class="your-kit-includes__item" data-component-name="${escapeHtml(component.name)}">
          ${imageHtml}
          <div class="your-kit-includes__item-details">
            <h4 class="your-kit-includes__item-title">${escapeHtml(displayTitle)}</h4>
            <span class="your-kit-includes__item-qty">${qtyHtml}</span>
          </div>
        </div>
      `;
    }
    
    function normalizeSize(size) {
      if (!size) return 'Small';
      const s = size.toLowerCase().trim();
      if (s === 'small' || s === 's') return 'Small';
      if (s === 'medium' || s === 'm') return 'Medium';
      if (s === 'large' || s === 'l') return 'Large';
      if (s === 'extra large' || s === 'xl' || s === 'extra-large') return 'Extra Large';
      if (s.startsWith('s')) return 'Small';
      if (s.startsWith('m')) return 'Medium';
      if (s.startsWith('l')) return 'Large';
      if (s.startsWith('x') || s.startsWith('e')) return 'Extra Large';
      return 'Small';
    }
    
    function normalizeSprayer(value) {
      if (!value) return null;
      const v = value.toLowerCase().trim();
      if (v.includes('g-force') || v.includes('gforce')) return 'g-force';
      if (v.includes('ultimate')) return 'ultimate';
      if (v.includes('no') || v.includes('have') || v.includes('already')) return 'none';
      return null;
    }
    
    function normalizeFinish(value) {
      if (!value) return 'standard';
      const v = value.toLowerCase().trim();
      if (v.includes('uhg') || v.includes('ultra') || v.includes('high gloss')) return 'uhg';
      return 'standard';
    }
    
    // Permanent kit: Primer selection normalizer
    function normalizePrimer(value) {
      if (!value) return false;
      const v = value.toLowerCase().trim();
      // "Requires Primer" / "Has Issues" = true, "Good Condition" / "No Issues" = false
      if (v.includes('primer') || v.includes('issues') || v.includes('requires')) return true;
      return false;
    }
    
    // Permanent kit: Clearcoat selection normalizer
    function normalizeClearcoat(value) {
      if (!value) return 'standard';
      const v = value.toLowerCase().trim();
      if (v.includes('vhs') || v.includes('crystal') || v.includes('premium')) return 'vhs';
      return 'standard';
    }
    
    function escapeHtml(str) {
      if (!str) return '';
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
    
    // Listen for car kit builder events
    document.addEventListener('dyc:carkit:size-changed', (e) => {
      const newSize = e.detail?.size || e.detail?.value;
      if (newSize) {
        currentSize = newSize;
        console.log('📦 Size changed:', currentSize);
        renderComponents();
      }
    });
    
    document.addEventListener('dyc:carkit:sprayer-changed', (e) => {
      const newSprayer = e.detail?.sprayer || e.detail?.value;
      if (newSprayer) {
        currentSprayer = normalizeSprayer(newSprayer);
        console.log('📦 Sprayer changed:', currentSprayer);
        renderComponents();
      }
    });
    
    document.addEventListener('dyc:carkit:finish-changed', (e) => {
      const newFinish = e.detail?.finish || e.detail?.value;
      if (newFinish) {
        currentFinish = normalizeFinish(newFinish);
        console.log('📦 Finish changed:', currentFinish);
        renderComponents();
      }
    });
    
    // Permanent kit: Listen for primer selection changes
    document.addEventListener('dyc:carkit:primer-changed', (e) => {
      const needsPrimer = e.detail?.primer || e.detail?.value;
      currentPrimer = normalizePrimer(needsPrimer);
      console.log('📦 Primer changed:', currentPrimer);
      renderComponents();
    });
    
    // Permanent kit: Listen for clearcoat selection changes
    document.addEventListener('dyc:carkit:clearcoat-changed', (e) => {
      const clearcoat = e.detail?.clearcoat || e.detail?.value;
      currentClearcoat = normalizeClearcoat(clearcoat);
      console.log('📦 Clearcoat changed:', currentClearcoat);
      renderComponents();
    });
    
    // Listen for variant changes (fallback)
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail?.variant;
      if (variant && variant.title) {
        const title = variant.title.toLowerCase();
        
        // Parse size (shared between peelable and permanent)
        if (title.includes('small')) currentSize = 'Small';
        else if (title.includes('medium')) currentSize = 'Medium';
        else if (title.includes('large') && !title.includes('extra')) currentSize = 'Large';
        else if (title.includes('extra large') || title.includes('xl')) currentSize = 'Extra Large';
        
        if (isPermanentKit) {
          // ===== PERMANENT KIT VARIANT PARSING =====
          
          // Parse primer selection
          if (title.includes('primer') || title.includes('has issues') || title.includes('requires primer')) {
            currentPrimer = true;
          } else if (title.includes('good') || title.includes('no issues')) {
            currentPrimer = false;
          }
          
          // Parse clearcoat selection
          if (title.includes('vhs') || title.includes('crystal')) {
            currentClearcoat = 'vhs';
          } else if (title.includes('standard')) {
            currentClearcoat = 'standard';
          }
          
          console.log('📦 Variant changed (PERMANENT), parsed:', { 
            size: currentSize, 
            primer: currentPrimer, 
            clearcoat: currentClearcoat 
          });
          
        } else {
          // ===== PEELABLE KIT VARIANT PARSING =====
          
          // Parse sprayer
          if (title.includes('g-force') || title.includes('gforce')) {
            currentSprayer = 'g-force';
          } else if (title.includes('ultimate')) {
            currentSprayer = 'ultimate';
          } else if (title.includes('no spray') || title.includes('have one')) {
            currentSprayer = 'none';
          }
          
          // Parse finish
          if (title.includes('uhg') || title.includes('ultra high gloss')) {
            currentFinish = 'uhg';
          } else if (title.includes('standard') || title.includes('matte') || title.includes('satin')) {
            currentFinish = 'standard';
          }
          
          console.log('📦 Variant changed (PEELABLE), parsed:', { 
            size: currentSize, 
            sprayer: currentSprayer, 
            finish: currentFinish 
          });
        }
        
        renderComponents();
      }
    });
    
    // Initial render
    renderComponents();
    
    // Export for debugging
    window.kitIncludesState = {
      get isPermanent() { return isPermanentKit; },
      get size() { return currentSize; },
      // Peelable kit state
      get sprayer() { return currentSprayer; },
      get finish() { return currentFinish; },
      // Permanent kit state
      get primer() { return currentPrimer; },
      get clearcoat() { return currentClearcoat; },
      render: renderComponents
    };
    console.log('🧪 Debug: window.kitIncludesState available', { isPermanent: isPermanentKit });
  }
})();
